import React, { useEffect } from "react";

const CancellationRefund = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4 md:px-10">
      <div className="max-w-5xl mx-auto bg-white shadow-sm border border-gray-200 rounded-lg p-8 md:p-12 text-[15px] leading-relaxed text-gray-700">
        
        {/* Header */}
        <div className="border-b pb-6 mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900 mb-2 uppercase">Return & Refund Policy</h1>
          <p className="text-sm text-gray-500 italic">
            Maya Enterprises (Mediiapp) strives to facilitate the processing of correct medicines as per your specialized prescription.
          </p>
          <p className="text-sm text-gray-600 mt-4 font-semibold">Last Updated: February 2026</p>
        </div>

        {/* 1. Definitions & Scope */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            1. Return Policy Overview
          </h2>
          <p className="mb-4">
            'Return' means the action of giving back the product ordered at the Mediiapp portal. Due to the critical nature of <strong>Kidney medicines</strong>, returns are strictly monitored. You may raise a return request within <strong>07 (Seven) days</strong> of delivery for the following reasons:
          </p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Product(s) delivered do not match your order.</li>
            <li>Product(s) delivered are past or near to its expiry date (less than 3 months).</li>
            <li>Product(s) were damaged in transit (please do not accept tampered seals).</li>
          </ul>
        </section>

        {/* 2. Non-Returnable Categories - Specialized for Transplant Meds */}
        <section className="mb-10 bg-red-50 p-6 rounded-lg border border-red-100">
          <h2 className="text-xl font-bold text-red-900 mb-3">2. Category of Non-Returnable Products</h2>
          <p className="mb-4 text-red-800">
            The following categories do not qualify for return due to safety and cold-storage requirements:
          </p>
          <ul className="list-disc ml-6 space-y-2 text-red-800">
            <li><strong>Temperature Controlled Medicines:</strong> Vials, Injections, and any product requiring cold storage (2°C to 8°C).</li>
            <li><strong>Specialty Medicines:</strong> Critical transplant medications that fall under the specialty category.</li>
            <li><strong>Opened Items:</strong> Partially consumed strips or opened original manufacturer packaging.</li>
          </ul>
        </section>

        {/* 3. Refund Process */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            3. Refund Process
          </h2>
          <p className="mb-4">
            Upon a valid return/refund request, Maya Enterprises will verify the authenticity of the claim within 72 business hours.
          </p>
          <ul className="list-disc ml-6 space-y-2">
            <li><strong>Online Payments:</strong> Refund will be credited to the original payment source (Wallet/Card/UPI).</li>
            <li><strong>Cash on Delivery:</strong> Refund will be processed via fund transfer to the customer’s verified bank account.</li>
            <li><strong>Timeline:</strong> The process is usually completed within 30 days from the date of reverse pick-up.</li>
          </ul>
        </section>

        {/* 4. Cancellation Policy */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4 border-l-4 border-green-600 pl-3">
            4. Cancellation Policy
          </h2>
          <p className="mb-4">
            <strong>Customer Cancellation:</strong> You can cancel your order until Maya Enterprises ships it. Orders already in transit cannot be cancelled.
          </p>
          <p className="mb-4">
            <strong>Maya Enterprises Cancellation:</strong> We reserve the right to cancel orders due to:
          </p>
          <ul className="list-disc ml-6 space-y-2">
            <li>Non-availability of the specialty medicine.</li>
            <li>Inaccuracies in pricing or errors in prescription validation.</li>
            <li>Identification of 'Bulk Orders' intended for commercial resale rather than self-consumption.</li>
          </ul>
        </section>

        {/* Contact/Grievance */}
        <section className="mt-10 pt-8 border-t border-gray-200 bg-gray-100 p-6 rounded-md">
          <p className="font-bold text-gray-900">Contact for Returns:</p>
          <p>Maya Enterprises, GF-39, Omaxe Square, Jasola, New Delhi - 110025</p>
          <p>Director: Dheeraj Khatwani</p>
          <p>Email: <a href="mailto:Mediiappindia@gmail.com" className="text-green-600 font-bold">Mediiappindia@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default CancellationRefund;